// Mel·Mel — pouch de regalo y barra de envío gratis en el carrito (22-oct-2026, pedido de Emi).
// 1. Pouch 11 oz (TRA-D11-MM) de regalo: uno desde $59 y dos desde $99, sin contar los pouches
//    del carrito. El precio $0 lo pone el descuento automático "Gift pouch" (BXGY); este script
//    solo agrega o saca la línea del regalo (propiedad _mm_gift) para que el cliente no tenga que hacerlo.
// 2. Barra "te faltan $X para envío gratis / para el pouch de regalo": sections/mm-promo-bar.liquid,
//    traída con la Section Rendering API e insertada arriba del total (drawer y página del carrito).
// 3. En la línea del regalo se ocultan cantidad, borrar y el aviso de mínimo 2 pouches.
// Se carga desde snippets/meta-tags.liquid (script clásico con defer, sin imports).
(function () {

const R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const POUCH = 47106585723052;
const T1 = 5900;
const T2 = 9900;
const H = { 'Content-Type': 'application/json', Accept: 'application/json' };
const GIFT = { _mm_gift: '1', Gift: 'Free pouch / Pouch de regalo' };
let busy = false;
let barHtml = '';

async function getCart() {
  const r = await fetch(R + 'cart.js', { headers: { Accept: 'application/json' } });
  return r.json();
}

async function post(path, body) {
  return fetch(R + path, { method: 'POST', headers: H, body: JSON.stringify(body) });
}

async function reconcile() {
  if (busy) return;
  busy = true;
  try {
    const cart = await getCart();
    let elig = 0;
    const gifts = [];
    for (const it of cart.items) {
      if (it.properties && it.properties._mm_gift) {
        gifts.push(it);
        continue;
      }
      if (it.variant_id !== POUCH) elig += it.final_line_price;
    }
    const want = elig >= T2 ? 2 : elig >= T1 ? 1 : 0;
    const have = gifts.reduce((s, l) => s + l.quantity, 0);
    if (want !== have || gifts.length > 1) {
      if (gifts.length > 1 || (want === 0 && have > 0)) {
        const updates = {};
        for (const l of gifts) updates[l.key] = 0;
        await post('cart/update.js', { updates });
        if (want > 0) await post('cart/add.js', { items: [{ id: POUCH, quantity: want, properties: GIFT }] });
      } else if (have === 0) {
        await post('cart/add.js', { items: [{ id: POUCH, quantity: want, properties: GIFT }] });
      } else {
        await post('cart/change.js', { id: gifts[0].key, quantity: want });
      }
      const fresh = await getCart();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: fresh, sourceId: 'mm-gift', data: { source: 'mm-gift', itemCount: fresh.item_count } } }));
    }
    await refreshBar();
  } catch (e) {
    console.warn('[mm-gift]', e);
  } finally {
    busy = false;
  }
}

async function refreshBar() {
  try {
    const r = await fetch(R + '?section_id=mm-promo-bar', { headers: { Accept: 'text/html' } });
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const sec = doc.querySelector('.shopify-section') || doc.body;
    barHtml = sec ? sec.innerHTML : '';
  } catch (e) {
    barHtml = '';
  }
  placeBar();
}

function placeBar() {
  for (const totals of document.querySelectorAll('.cart-totals')) {
    const prev = totals.previousElementSibling;
    if (prev && prev.classList.contains('mm-pb-host')) prev.remove();
    if (!barHtml.trim()) continue;
    const host = document.createElement('div');
    host.className = 'mm-pb-host';
    host.innerHTML = barHtml;
    totals.parentNode.insertBefore(host, totals);
  }
}

function markGiftLines() {
  for (const row of document.querySelectorAll('.cart-items__table-row, tr[data-key]')) {
    if (row.dataset.mmGift) continue;
    if (!/Free pouch \/ Pouch de regalo/.test(row.textContent || '')) continue;
    row.dataset.mmGift = '1';
    row.querySelectorAll('quantity-selector-component, cart-quantity-selector-component, .cart-items__remove, .mm-min-order-cart').forEach((el) => {
      el.style.display = 'none';
    });
  }
}

let tick = null;
const obs = new MutationObserver(() => {
  clearTimeout(tick);
  tick = setTimeout(() => {
    markGiftLines();
    const missing = [...document.querySelectorAll('.cart-totals')].some(
      (t) => !(t.previousElementSibling && t.previousElementSibling.classList.contains('mm-pb-host'))
    );
    if (missing && barHtml) placeBar();
  }, 120);
});

function start() {
  obs.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:update', (e) => {
    if (e.detail && e.detail.data && e.detail.data.source === 'mm-gift') {
      setTimeout(refreshBar, 400);
      return;
    }
    setTimeout(reconcile, 350);
  });
  markGiftLines();
  reconcile();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
})();
